<script>
    import {timer} from "../../helpers/timer";
    export let text = '';
    let script;
    $: {
        if(timer([9,20])) {
            let toki = document.querySelector('iframe[title="Toky Call Button"]');
            if(script) {
                //document.head.removeChild(script);
                script = undefined;
            }
            if(toki){
                //toki.parentElement.removeChild(toki);
                toki = undefined;
            } else {
                (function (p) {
                    var s = document.createElement('script');
                    script = s;
                    s.src = 'https://call-widget.toky.co/toky-call-widget';
                    s.onload = function () {
                        window.Toky("boot", p);
                    };
                    document.head.appendChild(s);
                })({"$username":"lobesoftllc","$option":"","$position":"left","$text":text})
            }
            }
    }
</script>

